// markers/clusterRenderer.js
// Custom Renderer compatible with @googlemaps/markerclusterer.
// Produces a "big dot+halo" with the cluster count centered, matching marker style.
const CLUSTER_TIERS = [
  { max: 10, scale: 13, strokeWeight: 24, fontSize: "13px" },
  { max: 50, scale: 17, strokeWeight: 30, fontSize: "14px" },
  { max: 200, scale: 23, strokeWeight: 36, fontSize: "15px" },
  { max: Infinity, scale: 27, strokeWeight: 44, fontSize: "16px" },
]

const getClusterTier = count =>
  CLUSTER_TIERS.find(t => count < t.max) || CLUSTER_TIERS[CLUSTER_TIERS.length - 1]

export const createClusterRenderer = color => ({
  render: ({ count, position }) => {
    const tier = getClusterTier(count)
    return new window.google.maps.Marker({
      position,
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: color,
        fillOpacity: 1,
        strokeColor: color,
        strokeOpacity: 0.22,
        strokeWeight: tier.strokeWeight,
        scale: tier.scale,
      },
      label: {
        text: String(count),
        color: "#ffffff",
        fontSize: tier.fontSize,
        fontWeight: "700",
        fontFamily: "Roboto, 'Segoe UI', sans-serif",
      },
      // Ensure clusters paint above the base layer and below the user's hover state
      zIndex: 1000 + count,
    })
  },
})
